<div [ngClass]="{ show: show }">
  <div class="host">
    <div [ngClass]="dialogclass">
      <ng-container #modalHost></ng-container>
    </div>
  </div>
</div>
